import { useEffect, useRef, useState } from 'react';
import Intercom from './components/Intercom';
import { getIntercomAppId } from './components/Intercom/utilities/helpers';

const HAS_INTERCOM_APP_ID = Boolean(getIntercomAppId());

const Plugins = () => {
  const [shouldRenderIntercom, setShouldRenderIntercom] = useState(false);
  const idleTimerRef = useRef(null);

  useEffect(() => {
    if (!HAS_INTERCOM_APP_ID) return;

    const enableIntercom = () => {
      if (typeof window === 'undefined') return;
      const activate = () => setShouldRenderIntercom(true);
      if ('requestIdleCallback' in window) {
        window.requestIdleCallback(activate, { timeout: 2000 });
      } else {
        idleTimerRef.current = window.setTimeout(activate, 1500);
      }
    };

    if (typeof document !== 'undefined' && document.readyState === 'complete') {
      enableIntercom();
    } else if (typeof window !== 'undefined') {
      window.addEventListener('load', enableIntercom);
    }

    return () => {
      if (typeof window !== 'undefined') {
        window.removeEventListener('load', enableIntercom);
      }
      if (idleTimerRef.current) {
        clearTimeout(idleTimerRef.current);
      }
    };
  }, []);

  if (!HAS_INTERCOM_APP_ID || !shouldRenderIntercom) return null;

  return <Intercom />;
};

export default Plugins;
